import { apiGet } from "../services/restApiService";
import { UserProfile } from "../types/types";

/**
 * Get current user profile data
 * @returns Promise<UserProfile>
 */
export async function getProfileData(): Promise<UserProfile> {
  return apiGet<UserProfile>("/users/me");
}
